import { render, staticRenderFns } from "./PButton.vue?vue&type=template&id=5b9277e0&scoped=true"
import script from "./PButton.vue?vue&type=script&lang=js"
export * from "./PButton.vue?vue&type=script&lang=js"
import style0 from "./PButton.vue?vue&type=style&index=0&id=5b9277e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9277e0",
  null
  
)

export default component.exports